import React from 'react';
import Search from './Search'

class SearchClaim extends Search {

  componentWillMount() {
    if (!sessionStorage.getItem('auth')) {
      browserHistory.push('/')
    }
    this.performSearch(this.props.location.query);
  }

}

export default SearchClaim;



// WEBPACK FOOTER //
// ./src/components/SearchClaim.js